import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_a6_etron() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_a6_etron(frontCheckboxesMap, modalsCheckboxesMap) {
    frontCheckboxesMap['Q8H_A6etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A6etron', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a6_etron(frontCheckboxesMap)
		}
		getPackageImages_a6_etron('Q8H_A6etron', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD_A6etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD_A6etron', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a6_etron(frontCheckboxesMap)
		}
		getPackageImages_a6_etron('0UD_A6etron', frontCheckboxesMap)
	})

	
	frontCheckboxesMap['7TZ_A6etron'].addEventListener('change', function () {
			checkSubmit(frontCheckboxesMap)
			saveStateWithAjax('7TZ_A6etron', this.checked);
			if (this.checked) {
				//If we dont come from the modal
	
			} else {
				checkLocks_a6_etron(frontCheckboxesMap)
			}
			getPackageImages_a6_etron('7TZ_A6etron', frontCheckboxesMap)
		})
			
	
	frontCheckboxesMap['FZ9_A6etron'].addEventListener('change', function () {		

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9_A6etron', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ8_A6etron'].checked == false) { 
				frontCheckboxesMap['FZ8_A6etron'].disabled = true
			}
		} else {
			checkLocks_a6_etron(frontCheckboxesMap)
		}
		getPackageImages_a6_etron('FZ9_A6etron', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['FZ8_A6etron'].addEventListener('change', function () {		

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ8_A6etron', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ9_A6etron'].checked == false) { 
				frontCheckboxesMap['FZ9_A6etron'].disabled = true
			}
		} else {
			checkLocks_a6_etron(frontCheckboxesMap)
		}
		getPackageImages_a6_etron('FZ8_A6etron', frontCheckboxesMap)
	})
	
    frontCheckboxesMap['0TF_A6etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF_A6etron', this.checked);
		if (this.checked) {
			//If we dont come from the modal
		} else {
			checkLocks_a6_etron(frontCheckboxesMap)
		}
		getPackageImages_a6_etron('0TF_A6etron', frontCheckboxesMap)
	})


}

/**Controls frontcheckboxes disable */
function checkLocks_a6_etron(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
	const unlockConditionForQ8H_7HH = true
	const unlockConditionFor0UD = true
	const unlockConditionFor7TZ = true
	const unlockConditionForFZ8 = !frontCheckboxesMap['FZ9_A6etron'].checked
	const unlockConditionForFZ9 = !frontCheckboxesMap['FZ8_A6etron'].checked
	const unlockConditionFor0TF = true

	frontCheckboxesMap['Q8H_A6etron'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD_A6etron'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['7TZ_A6etron'].disabled = !unlockConditionFor7TZ
	frontCheckboxesMap['FZ9_A6etron'].disabled = !unlockConditionForFZ9
	frontCheckboxesMap['FZ8_A6etron'].disabled = !unlockConditionForFZ8
	frontCheckboxesMap['0TF_A6etron'].disabled = !unlockConditionFor0TF
}


/**Gets images for all packages depending on selected packages */

function getImages_a6_etron(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a6_etron(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a6_etron(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_a6_etron, saveStateWithAjax, checkLocks_a6_etron, getImages_a6_etron, getPackageImages_a6_etron, checkSeatsAndSteeringWheelBadges_a6_etron}

